/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import Header from '../../components/includes/Header';
import HeaderTitle from '../../components/includes/HeaderTitle';
import { MaskingString } from '../../components/common/Common';

import "../../css/style.css";

//아이디 찾기
const FoundIDOK = () => {
  const mem_id = localStorage.getItem("foundID");
  const [varMemberID,setMemberID] = useState();
  //입력정보저장객체
  useEffect(() => {
    const ilen = mem_id.length - 2;
    const memberID = MaskingString(mem_id,ilen,'*');
    setMemberID(memberID);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="vh-container">
      <Header varGoToMain={false} />
      <div className="vh-content">
        <HeaderTitle varPageTitle={'아이디 찾기'}/>
        <div className="vh-content-body">
          <div className="form-result-wrap">
            <div className="form-result-desc mb10">고객님의 아이디는</div>
            <div className="form-result">
              <div className="form-result-value">{varMemberID}</div>
              <span>입니다.</span>
            </div>
          </div>
					<div className="form-contoller flex-horizontal mt-auto mb50">
						<Link to="/Login" className="form-contoller-btn">로그인하기</Link>
					</div>
        </div>
      </div>
    </div>
  );
}
export default FoundIDOK;